import React from "react";
import { MessageCircle } from "lucide-react";

const WA_NUMBER = "971501227625";
const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

/** Tabby + WhatsApp support strip — shown on every step of both checkout dialogs */
export const CheckoutSupportStrip = () => (
  <div
    data-testid="checkout-support-strip"
    className="bg-bone border-t border-hairline px-6 md:px-8 py-3.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5 sm:gap-4"
  >
    <a
      href={waLink(
        "Hi Thrive by Madsen! I'd like to pay with Tabby — please send me a Tabby payment link.",
      )}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="tabby-whatsapp-link"
      className="group inline-flex items-center gap-2.5"
    >
      <img
        src="/images/tabby-wordmark.png"
        alt="Tabby"
        className="h-4 w-auto opacity-90 group-hover:opacity-100 transition-opacity"
      />
      <span className="text-xs text-inkmute group-hover:text-ink transition-colors">
        Prefer Tabby?{" "}
        <span className="font-display font-semibold text-ink group-hover:text-terracotta link-underline transition-colors">
          Message us on WhatsApp
        </span>
      </span>
    </a>
    <a
      href={waLink("Hi Thrive by Madsen! I have a question about my order.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-help-link"
      className="group inline-flex items-center gap-1.5 text-xs text-inkmute hover:text-terracotta transition-colors whitespace-nowrap"
    >
      <MessageCircle className="w-3.5 h-3.5" strokeWidth={1.75} />
      Questions?{" "}
      <span className="font-display font-semibold link-underline whitespace-nowrap">
        WhatsApp us
      </span>
    </a>
  </div>
);
